import script from "./XInputText.vue?vue&type=script&lang=ts&setup=true"
export * from "./XInputText.vue?vue&type=script&lang=ts&setup=true"

import "./XInputText.vue?vue&type=style&index=0&id=0a055680&lang=css&scoped=true"

import exportComponent from "D:\\x1\\vue3-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a055680"]])

export default __exports__